import { useDispatch } from 'react-redux';
import axiosPrivate from 'config/axiosPrivate';

import { animationUrl } from 'config/endpoints';

import { transformToSemanticGap } from 'helpers/FormatKeywordsHelper';

import { updateForm, updateTextForm } from 'store/Writer/Analyser';
import { updateTextOfTextList } from 'store/Writer/OrderDisplay';

export const useWriterSendRevision = ({
  t,
  actualHtmlContent,
  actualTextContent,
  analyseResult,
  keyword,
  metaDescriptionTag,
  combinedKeywords,
  setIsFetchLoading,
  setErrorSuccessMsg,
  setErrorSuccessImg,
  setErrorSuccess,
  formData,
  setIsSuccess,
}) => {
  const dispatch = useDispatch();

  const sendRevision = () => {
    setIsFetchLoading(true);

    axiosPrivate
      .put(`/texts/${formData.id}/revisionDone`, {
        actualHtmlContent: actualHtmlContent,
        actualTextContent: actualTextContent,
        analyseResult: analyseResult && JSON.stringify(analyseResult),
        keyword: keyword,
        metaDescriptionTag: metaDescriptionTag,
        semanticGap: transformToSemanticGap(combinedKeywords),
      })
      .then((res) => {
        setIsFetchLoading(false);
        dispatch(updateForm(res.data));
        dispatch(updateTextForm({ key: 'revisionDone', value: true }));
        dispatch(
          updateTextOfTextList({
            id: formData.id,
            key: 'revisionDone',
            value: true,
          })
        );

        setErrorSuccessMsg(`${t('Modification effectuée avec succès')}`);
        setErrorSuccessImg(animationUrl + '/09_Repasse_OK.gif');
        setIsSuccess(true);
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsFetchLoading(false);

        setErrorSuccessMsg(`Oups...! ${t("Une erreur s'est produite")}.`);
        setIsSuccess(false);
        setErrorSuccess(true);
      });
  };

  return { sendRevision };
};
